// Module
var code = "<div class=\"resources-container container fade-in\"><h2>Resources Stub</h2></div>";
// Exports
export default code;